import { JWT_IS_EXPIRED_ERROR_MESSAGE } from "../auth/authClient/src/constants";
import { getBearerHeader, getTokenFromRefreshToken } from "../auth/AuthUtility";
import HttpErrorResponseModel from "../models/HttpErrorResponseModel";
import * as HttpUtility from "./HttpUtility";

export async function getToModel(Model, endpoint, params = {}, secured = true, throwException = false) {
    const response = await sendRequestWithBearer(HttpUtility.get, endpoint, params, secured, throwException);

    return _restModelCreator(Model, response);
}

export async function postToModel(Model, endpoint, data = {}, secured = true, throwException = false) {
    const response = await sendRequestWithBearer(HttpUtility.post, endpoint, data, secured, throwException);

    return _restModelCreator(Model, response);
}

export async function putToModel(Model, endpoint, data = {}, secured = true, throwException = false) {
    const response = await sendRequestWithBearer(HttpUtility.put, endpoint, data, secured, throwException);

    return _restModelCreator(Model, response);
}

export async function deleteToModel(Model, endpoint, data={}, secured = true, throwException = false) {
    const response = await sendRequestWithBearer(HttpUtility.del, endpoint, data, secured, throwException);

    return _restModelCreator(Model, response);
}

function _restModelCreator(Model, response) {
    if (response instanceof HttpErrorResponseModel) {
        return response;
    }

    return !Array.isArray(response.data) ? new Model(response.data) : response.data.map((json) => new Model(json));
}

export async function sendRequestWithBearer(requestFunction, endpoint, params = {}, secured, throwException = false) {
    let response = await requestFunction(endpoint, secured ? getBearerHeader() : {}, params);
    if (response instanceof HttpErrorResponseModel) {
        if (response.raw?.data === JWT_IS_EXPIRED_ERROR_MESSAGE) {
            const resendResponse = await getTokenFromRefreshToken();
            if (resendResponse) {
                response = await requestFunction(endpoint, getBearerHeader(), params);
            }

        }
        if (throwException) throw response;
    }
    return response;
}
